'use client'

import Image from 'next/image'

import Comment1 from '@/public/img/comentario-1.webp'
import Comment2 from '@/public/img/comentario-2.webp'
import Comment3 from '@/public/img/comentario-3.webp'
import Comment4 from '@/public/img/comentario-4.webp'
import Comment5 from '@/public/img/comentario-5.webp'
import Comment6 from '@/public/img/comentario-6.webp'

export default function CommentsSection() {
  return (
    <section className="bg-gray-50 pt-16 pb-8">
      <div className="m-auto max-w-60 lg:max-w-full">
        <h2 className="text-center font-bold text-2xl text-[#430283]">
          O que os nossos alunos acharam da Formação
        </h2>
      </div>
      <div className="mx-auto mt-4 flex max-w-280.25 flex-wrap justify-center gap-x-6 gap-y-4 lg:mt-6 lg:text-2xl">
        <div className="flex flex-col gap-y-4">
          <Image alt="" src={Comment5} />
          <Image alt="" src={Comment2} />
        </div>
        <div className="flex flex-col gap-y-4">
          <Image alt="" src={Comment4} />
          <Image alt="" src={Comment1} />
        </div>
        <div className="flex flex-col gap-y-4">
          <Image alt="" src={Comment3} />
          <Image alt="" src={Comment6} />
        </div>
      </div>
    </section>
  )
}
